import { createContext } from "react";

interface DataTableColumnSizing {
  columnSizing: Record<string, number>;
}

const DataTableColumnSizingContext =
  createContext<DataTableColumnSizing | null>(null);

export default DataTableColumnSizingContext;
